
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/for-buyers",
      function () {
        return require("private-next-pages/faq/for-buyers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/for-buyers"])
      });
    }
  